<template>
	<ECommerceAddToCartButton
		:product="eCommerceProduct"
		:segment="segment"
		:disabled="disableAddToCart"
		:modalProps="modalProps"
		:size="size"
	/>
</template>
<script>
import ECommerceProductMixin from "../../ECommerceProductMixin/ECommerceProductMixin.js";
export default defineNuxtComponent({
	mixins: [ECommerceProductMixin],
	props: ["disableAddToCart", "swapPhoneAddToCartText", "modalProps", "size"],

	computed: {
		segment() {
			return this.$store.getters["ecommerce/segment"];
		},
	},

	data() {
		return {
			host: undefined,
		};
	},

	mounted() {
		this.host = window.location.host;
	},
});
</script>
<style lang="scss" scoped></style>
